module.exports = __webpack_public_path__ + "img/nyc-buildings.41a89b1e.jpg";